"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const buttonStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    width: '20px',
    height: '20px',
    margin: 'auto',
};
function ColorIndicator1D({ display }) {
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            backgroundColor: display.color,
            height: '12px',
            width: '12px',
            margin: 'auto',
        } }));
}
function ColorIndicator2D({ display }) {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "12", height: "12", viewBox: "0 0 12 12", style: { margin: 'auto' }, children: (0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0,0H12L0,12Z", fill: display.positiveColor, strokeWidth: "0" }), (0, jsx_runtime_1.jsx)("path", { d: "M12,12H0L12,0Z", fill: display.negativeColor, strokeWidth: "0" })] }) }));
}
function ColorIndicator(props) {
    const { onClick = () => null, display, dimension } = props;
    return ((0, jsx_runtime_1.jsx)("button", { style: buttonStyle, type: "button", onClick: onClick, children: dimension === 2 ? ((0, jsx_runtime_1.jsx)(ColorIndicator2D, { display: display })) : ((0, jsx_runtime_1.jsx)(ColorIndicator1D, { display: display })) }));
}
exports.default = (0, react_1.memo)(ColorIndicator);
